import type { CrmTranslate } from './crm-copy';

export function createCrmRuntimeCopy(t: CrmTranslate) {
  return {
    pipelineAction: {
      inStageTitle: (stageName: string | undefined) =>
        t('crm.pipelineAction.inStageTitle', {
          values: { stageName },
        }),
      inStageLabel: (stageName: string | undefined) =>
        t('crm.pipelineAction.inStageLabel', {
          values: { stageName },
        }),
      addTitle: t('crm.pipelineAction.addTitle'),
      addLabel: t('crm.pipelineAction.addLabel'),
      addStageHeading: t('crm.pipelineAction.addStageHeading'),
      loadingStages: t('crm.pipelineAction.loadingStages'),
      cancel: t('crm.pipelineAction.cancel'),
    },
    errorBoundary: {
      title: t('crm.errorBoundary.title'),
      message: t('crm.errorBoundary.message'),
      detailsSummary: t('crm.errorBoundary.detailsSummary'),
      tryAgain: t('crm.errorBoundary.tryAgain'),
      refreshPage: t('crm.errorBoundary.refreshPage'),
    },
    inboxPage: {
      documentTitle: t('crm.inboxPage.documentTitle'),
      title: t('crm.inboxPage.title'),
      conversationsTitle: t('crm.inboxPage.conversationsTitle'),
    },
    appShell: {
      sentryFallback: t('crm.appShell.sentryFallback'),
    },
    documentTitle: {
      defaultTitle: t('crm.documentTitle.defaultTitle'),
      suffix: t('crm.documentTitle.suffix'),
      withSuffix: (title: string) =>
        t('crm.documentTitle.withSuffix', {
          values: { title },
        }),
    },
    dateUtils: {
      notAvailable: t('crm.dateUtils.notAvailable'),
      invalidDate: t('crm.dateUtils.invalidDate'),
      justNow: t('crm.dateUtils.justNow'),
      minutesAgo: (count: number) =>
        t('crm.dateUtils.minutesAgo', {
          values: { count },
        }),
      minuteAgo: t('crm.dateUtils.minuteAgo'),
      hoursAgo: (count: number) =>
        t('crm.dateUtils.hoursAgo', {
          values: { count },
        }),
      hourAgo: t('crm.dateUtils.hourAgo'),
      daysAgo: (count: number) =>
        t('crm.dateUtils.daysAgo', {
          values: { count },
        }),
      dayAgo: t('crm.dateUtils.dayAgo'),
    },
    api: {
      errors: {
        generic: t('crm.api.errors.generic'),
        network: t('crm.api.errors.network'),
        uploadFailed: t('crm.api.errors.uploadFailed'),
        readFileFailed: t('crm.api.errors.readFileFailed'),
        downloadTemplateFailed: t('crm.api.errors.downloadTemplateFailed'),
      },
    },
    mutationMessages: {
      contacts: {
        created: t('crm.mutationMessages.contacts.created'),
        createFailed: t('crm.mutationMessages.contacts.createFailed'),
        updated: t('crm.mutationMessages.contacts.updated'),
        updateFailed: t('crm.mutationMessages.contacts.updateFailed'),
        deleted: t('crm.mutationMessages.contacts.deleted'),
        deleteFailed: t('crm.mutationMessages.contacts.deleteFailed'),
        movedToStage: t('crm.mutationMessages.contacts.movedToStage'),
        moveFailed: t('crm.mutationMessages.contacts.moveFailed'),
      },
      settings: {
        updated: t('crm.mutationMessages.settings.updated'),
        updateFailed: t('crm.mutationMessages.settings.updateFailed'),
      },
      companies: {
        loadFailed: t('crm.mutationMessages.companies.loadFailed'),
      },
      notes: {
        added: t('crm.mutationMessages.notes.added'),
        addFailed: t('crm.mutationMessages.notes.addFailed'),
        deleted: t('crm.mutationMessages.notes.deleted'),
        deleteFailed: t('crm.mutationMessages.notes.deleteFailed'),
      },
      attachments: {
        uploaded: t('crm.mutationMessages.attachments.uploaded'),
        uploadFailed: t('crm.mutationMessages.attachments.uploadFailed'),
        deleted: t('crm.mutationMessages.attachments.deleted'),
        deleteFailed: t('crm.mutationMessages.attachments.deleteFailed'),
      },
      deals: {
        created: t('crm.mutationMessages.deals.created'),
        createFailed: t('crm.mutationMessages.deals.createFailed'),
        updated: t('crm.mutationMessages.deals.updated'),
        updateFailed: t('crm.mutationMessages.deals.updateFailed'),
        deleted: t('crm.mutationMessages.deals.deleted'),
        deleteFailed: t('crm.mutationMessages.deals.deleteFailed'),
        movedToStage: t('crm.mutationMessages.deals.movedToStage'),
        moveFailed: t('crm.mutationMessages.deals.moveFailed'),
      },
    },
  };
}
